import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ForgotPasswordScreen } from '@/screens/accounts/SCR-104-105-password'

// SCR-104 Forgot password (accounts area).
export const Route = createFileRoute('/_public/forgot-password')({
  validateSearch: z.object({ email: z.string().max(200).optional().catch(undefined) }),
  component: function ForgotPassword() {
    return <ForgotPasswordScreen search={Route.useSearch()} />
  },
})
